// Library imports
import React, { useRef, useState } from "react";

// User Component imports
import { openVideoInNewTab } from "../utils/videoFile";

/**
 * 動画のプレビュー（16:9）。クリックで再生／停止、右上から新しいタブで再生
 */
const OpsVideoTile = ({ url, title }) => {
    const videoRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [playing, setPlaying] = useState(false);

    const toggle = () => {
        const video = videoRef.current;
        if (!video) return;
        if (video.paused) video.play().catch(() => {});
        else video.pause();
    };

    return (
        <div className="ops-video-tile" onClick={toggle}>
            <video ref={videoRef} src={url} preload="metadata" muted loop playsInline
                onLoadedData={() => setLoading(false)} onError={() => setLoading(false)}
                onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} />
            {loading && <div className="ops-video-loading"><i className="bi bi-arrow-repeat" />読み込み中…</div>}
            {!playing && !loading && <div className="ops-video-play"><span><i className="bi bi-play-fill" /></span></div>}
            <button type="button" className="ops-video-open" title="新しいタブで再生します"
                onClick={(e) => { e.stopPropagation(); openVideoInNewTab(url, title); }}>
                <i className="bi bi-box-arrow-up-right" />
            </button>
        </div>
    );
};

export default OpsVideoTile;
